import { Link } from "react-router-dom"
import { useQuery } from "@tanstack/react-query"
import { api } from "@/lib/api"
import type { NewsletterListItem } from "@/types/api"
import { formatDate } from "@/lib/utils"

export default function NewslettersPage() {
  const { data, isLoading } = useQuery({
    queryKey: ["newsletters"],
    queryFn: () => api.get<NewsletterListItem[]>("/newsletters?limit=30"),
  })

  return (
    <div>
      <header className="mb-6">
        <h1 className="text-2xl font-semibold tracking-tight">뉴스레터 아카이브</h1>
      </header>
      {isLoading && <div className="text-sm text-muted-foreground">불러오는 중...</div>}
      <ul className="divide-y divide-border rounded-md border border-border bg-card">
        {data?.map((nl) => (
          <li key={nl.id}>
            <Link to={`/newsletters/${nl.id}`} className="block px-4 py-3 hover:bg-secondary/50">
              <div className="flex items-baseline justify-between gap-3">
                <div>
                  <div className="font-medium">{nl.title}</div>
                  <div className="text-xs text-muted-foreground">
                    {formatDate(nl.issue_date)} · {nl.frequency} · {nl.item_count} papers
                  </div>
                </div>
                {nl.sent_at && (
                  <span className="text-xs text-muted-foreground">발송 {formatDate(nl.sent_at)}</span>
                )}
              </div>
              {nl.intro_ko && <p className="mt-1 line-clamp-2 text-sm text-muted-foreground">{nl.intro_ko}</p>}
            </Link>
          </li>
        ))}
      </ul>
    </div>
  )
}
